import { Person } from './person';

export class User {
	id: string;
	username: string;
	password: string;
	email: string;
	user_person_id: string;
	person: Person;
	enabled: boolean;
	created: Date;
	ip_address: string;
	evet_id: string;
	evet_user_type: string;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}


}